<template>
  <div class="holder">
  <input
    :id="id"
    :type="type"
    v-model="data"
    class="form-control"
    @input="emmitEvent"
    @keydown="emitKeydown"
    @change="emitChange"
    v-mask="mask"
    :aria-labelledby="'iban_label'"
    :maxlength="maxlength"
  >
  <span class="counter text-muted" v-if="maxlength">{{charactersLeft}}</span>
</div>
</template>

<script>
import Vue from "vue";

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import IcInput from "./Input";

export default {
  name: "IcInputBankAccount",
  extends: IcInput,
  props: {
    value: {
      type: String,
      default: ""
    },
    defaultPrefix: {
      default: "PL"
    },
    showPrefix: {
      type: Boolean,
      default: false
    },
   
    maxlength: { type: [String, Number], default: 50 },
     
  },
  computed: {
    mask: function() {
      return (
        this.showPrefix ?  
        
        ["AA XX XXXX XXXX XXX","AA XX XXXX XXXX XXXX","AA XX XXXX XXXX XXXX X","AA XX XXXX XXXX XXXX XX","AA XX XXXX XXXX XXXX XXX","AA XX XXXX XXXX XXXX XXXX","AA XX XXXX XXXX XXXX XXXX X","AA XX XXXX XXXX XXXX XXXX XX","AA XX XXXX XXXX XXXX XXXX XXX","AA XX XXXX XXXX XXXX XXXX XXXX","AA XX XXXX XXXX XXXX XXXX XXXX X","AA XX XXXX XXXX XXXX XXXX XXXX XX","AA XX XXXX XXXX XXXX XXXX XXXX XXX","AA XX XXXX XXXX XXXX XXXX XXXX XXXX","AA XX XXXX XXXX XXXX XXXX XXXX XXXX X","AA XX XXXX XXXX XXXX XXXX XXXX XXXX XX","AA XX XXXX XXXX XXXX XXXX XXXX XXXX XXX)"]:
               
        ["XX XXXX XXXX XXX","XX XXXX XXXX XXXX","XX XXXX XXXX XXXX X","XX XXXX XXXX XXXX XX","XX XXXX XXXX XXXX XXX","XX XXXX XXXX XXXX XXXX","XX XXXX XXXX XXXX XXXX X","XX XXXX XXXX XXXX XXXX XX","XX XXXX XXXX XXXX XXXX XXX","XX XXXX XXXX XXXX XXXX XXXX","XX XXXX XXXX XXXX XXXX XXXX X","XX XXXX XXXX XXXX XXXX XXXX XX","XX XXXX XXXX XXXX XXXX XXXX XXX","XX XXXX XXXX XXXX XXXX XXXX XXXX","XX XXXX XXXX XXXX XXXX XXXX XXXX X","XX XXXX XXXX XXXX XXXX XXXX XXXX XX","XX XXXX XXXX XXXX XXXX XXXX XXXX XXX"]
      );
    }
  },
  data() {
    return {
      data:
        (this.showPrefix ? this.defaultPrefix : "") +
        this.value.toUpperCase().replace(this.defaultPrefix)
    };
  }
};
</script>

<style>
.holder {
  position: relative;
}
.counter {
  position: absolute;
margin-top: -34px;
right: 10px;
font-size: 70%;
}
</style>
